import { AfterContentInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { EditSchainService, GeneralSchainService } from '../../services';
import { CreateSspSourceComponent } from '../create-ssp-source';
import { SourceSchainInterface } from '../../models';
import { DropdownInterface } from '../../../../core/models';
import { AuthService } from '../../../../core/services';
import { sourceSchainRowLimitDescription } from '../../helpers/source-schain-partner-messages';

@Component({
  selector: 'app-edit-ssp-source',
  standalone: false,
  templateUrl: './edit-ssp-source.component.html',
  styleUrl: './edit-ssp-source.component.scss'
})
export class EditSspSourceComponent implements OnInit, AfterContentInit {

  public data = inject(NZ_MODAL_DATA) as {
    sourceData: SourceSchainInterface.ISourceSchain;
    checkedCompanies: number[];
    companies: DropdownInterface.ICompaniesDataGeneralSource[];
  };

  protected contentHeight = 'auto';
  protected listOfCheckboxesMaxHeight = 800;

  @ViewChild('fileInput') protected fileInput: ElementRef;

  constructor(
    protected generalSchainService: GeneralSchainService,
    protected editSchainService: EditSchainService,
    private dialogRef: NzModalRef<CreateSspSourceComponent>,
    private authService: AuthService,
  ) { }

  protected get rowLimitDescription(): string {
    return sourceSchainRowLimitDescription(this.authService.partner.id);
  }


  public ngOnInit(): void {
    this.editSchainService.initComponent(this.data);
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 100 + 'px';
    this.listOfCheckboxesMaxHeight = window.innerHeight - 340;
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 100 + 'px';
      this.listOfCheckboxesMaxHeight = window.innerHeight - 340;
    });
  }

  protected onUploadFile(event: Event): void {
    this.editSchainService.onUploadFileHandler(event, () => this.fileInput.nativeElement.value = '', 'ssp');
  }

  protected onDownloadFile(): void {
    this.editSchainService.onDownloadFileHandler();
  }

  protected onDeleteFile(): void {
    this.editSchainService.onDeleteFileHandler();
  }

  protected onCancelUpload(): void {
    this.editSchainService.onCancelUploadHandler('ssp');
  }

  protected onCloseModal(): void {
    this.editSchainService.onCloseModalHandler((value: boolean) => this.dialogRef.close(value));
  }

  protected onUpdateSspSource(): void {
    this.editSchainService.onUpdateSourceSchainHandler(() => this.dialogRef.close(), 'ssp');
  }
}
